/**
 * Visible loading cue – spinner, message, and optional skeleton blocks.
 */

import React from 'react';
import './LoadingBlock.css';

export default function LoadingBlock({ message = 'Loading…', skeletonRows = 0, className = '', fullPage = false }) {
  const containerClass = fullPage
    ? `loading-block loading-block-full ${className}`.trim()
    : `loading-block ${className}`.trim();

  return (
    <div className={containerClass} role="status" aria-live="polite" aria-busy="true">
      <div className="loading-block-spinner" aria-hidden />
      <p className="loading-block-message">{message}</p>
      {skeletonRows > 0 && (
        <div className="loading-block-skeletons">
          {Array.from({ length: skeletonRows }, (_, i) => (
            <div key={i} className="loading-block-skeleton" />
          ))}
        </div>
      )}
    </div>
  );
}

export function SkeletonBar({ width = '100%', height = 12, className = '' }) {
  return (
    <div
      className={`loading-block-skeleton-bar ${className}`.trim()}
      style={{ width, height }}
      aria-hidden
    />
  );
}
